module.exports = __webpack_public_path__ + "img/union-pay.6553a07.svg";